import { useSelector } from "react-redux";
import { showFeature } from "../../lib/featureUtils";
import { getProjectionCode, key, trans } from "../../lib/utils";
import store from "../../stores/store";
import { getFeatureInfo, getMapCenter } from "./mapUtils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useState } from "react";

function Bookmarks() {
  const boomkmarks = useSelector((state) => store.getState().map.bookmarks);

  const layers = useSelector((state) => store.getState().layers);
  const sources = useSelector((state) => store.getState().sources);

  const [projection, setProjection] = useState("EPSG:4326");
  const [coords, setCoords] = useState([]);
  const [label, setLabel] = useState();
  const [zoom, setZoom] = useState(9);

  const [showAdd, setShowAdd] = useState(false);

  const showPoint = (_coords, _projection, _zoom) => {
    let feature = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: _coords,
      },
      projection: _projection,
      id: key(),
    };

    showFeature(feature, null, _zoom);
  };

  const addBookmark = () => {
    return (
      <div className="card">
        <div className="card-body">
          <div className="mb-3">
            <label className="color-get-blue strong ">{trans("Label")}</label>
            <input
              type="text"
              className="form-control form-control-sm mt-2"
              placeholder={trans("Set a label")}
              value={label}
              onChange={(e) => {
                setLabel(e.target.value);
              }}
            ></input>
          </div>
          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Select projection system")}
            </label>
            <div className="mt-2 input-group">
              <select
                className="form-select form-select-sm mt-2"
                value={projection}
                onChange={(e) => {
                  setProjection(e.target.value);
                }}
              >
                {window["appConfig"]()["projectionSystems"].map((opt) => {
                  return (
                    <option value={getProjectionCode(opt.code)}>
                      {opt.title}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Longitude")}
            </label>
            <input
              type="number"
              placeholder={trans("Set longitude")}
              value={coords[0]}
              className="form-control form-control-sm mt-2"
              onChange={(e) => {
                let _coord = coords;

                setCoords([Number(e.target.value), _coord[1]]);
              }}
            ></input>
          </div>
          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Latitude")}
            </label>
            <input
              type="number"
              className="form-control form-control-sm mt-2"
              placeholder={trans("Set latitude")}
              value={coords[1]}
              onChange={(e) => {
                let _coord = coords;

                setCoords([_coord[0], Number(e.target.value)]);
              }}
            ></input>
          </div>

          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Set zoom level")}
            </label>
            <select
              className="form-select form-select-sm mt-2"
              value={zoom}
              onChange={(e) => {
                window["map"]?.getView().setZoom(e.target.value);
                setZoom(window["map"]?.getView().getZoom());
              }}
            >
              {[5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].map((el) => {
                return <option value={el}>{el} </option>;
              })}
            </select>
          </div>
          <div className="mb-3 text-end">
            <button className="btn btn-white border  btn-sm me-2">
              <span
                className=" small"
                onClick={() => {
                  setProjection(
                    window["map"].getView().getProjection().getCode()
                  );
                  setCoords(getMapCenter());

                  setZoom(window["map"].getView().getZoom());
                }}
              >
                {trans("Get current map")}
              </span>
            </button>
            <button className="btn btn-white border  btn-sm me-2">
              <span
                className="small"
                onClick={() => {
                  let point = {
                    projection: projection,
                    event: { coordinate: coords, pixel: [] },
                    label: label,
                    zoom: zoom,
                  };
                  showPoint(coords, point.projection, zoom);
                }}
              >
                {trans("Show point")}
              </span>
            </button>
            <button className="btn btn-success  btn-sm">
              <span
                className="text-white small"
                onClick={() => {
                  let point = {
                    projection: projection,
                    event: { coordinate: coords, pixel: [] },
                    label: label,
                    zoom: zoom,
                  };
                  store.dispatch({ type: "map/bookmarks/add", payload: point });
                  setTimeout(window["recaclulatePerfectScrollbarHeight"], 0);
                }}
              >
                {trans("Save")}
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="mt-2">
      <div className="text-end">
        {!showAdd ? (
          <span
            className="pointer small"
            onClick={() => {
              setCoords([]);
              setLabel("");
              setShowAdd(true);

              setTimeout(window["recaclulatePerfectScrollbarHeight"], 0);
            }}
          >
            <i className="fas fa-plus me-1 small"></i>
            {trans("Add bookmark")}
          </span>
        ) : (
          <span
            className="pointer small"
            onClick={() => {
              setShowAdd(false);
              setTimeout(window["recaclulatePerfectScrollbarHeight"], 0);
            }}
          >
            {trans("Hide form")}
          </span>
        )}
      </div>
      {showAdd ? <div className="mt-2">{addBookmark()}</div> : ""}
      <PerfectScrollbar className="scrollbar-recaclulate">
        <div className="me-3">
          {boomkmarks?.map((el, index) => {
            let idx = boomkmarks.length - index;

            return (
              <div className="card mt-3 ">
                <div className="  me-2 mt-1 d-flex ps-3 pt-2" role="button">
                  <span className="color-get-blue w-100 small">
                    {el.label.concat(idx)}
                  </span>
                  <i
                    className="fas fa-trash-alt color-black fa-sm"
                    onClick={() => {
                      store.dispatch({
                        type: "map/bookmarks/delete",
                        payload: index,
                      });
                      setTimeout(
                        window["recaclulatePerfectScrollbarHeight"],
                        0
                      );
                    }}
                  ></i>
                </div>
                <div className="card-body">
                  <div className=" text-end">
                    <button className="btn btn-success btn-sm">
                      <span
                        className="text-white small"
                        onClick={() => {
                          showPoint(
                            el.event.coordinate,
                            el.projection,
                            el.zoom
                          );
                        }}
                      >
                        {trans("Go to")}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </PerfectScrollbar>
    </div>
  );
}

export default Bookmarks;
